import { Directive, HostListener, Input } from '@angular/core';
import { App } from '@df/core/app';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';

/**
 * ## Usage
 *
 * ```html
 * <a ... [gtmTrackProductClick]="{category: C, action: A, value: V, label: E}">...</a>
 * ```
 */
@Directive()
export abstract class GtmTrackProductClickDirectiveDef {
    @Input()
    gtmTrackProductClick?: Gtm.ITrackProductClickData;

    constructor(private gtmService: GtmService, private app: App) {}

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        const data = this.gtmTrackProductClick;
        if (data) {
            const model = data.productId ? this.app.resources.product.getExisting(data.productId) : undefined;

            if (model) {
                this.gtmService.trackProductClick(model, data.list || this.gtmService.getDefaultListName(), data.position);
            }
        }
    }
}
